// @flow
import { createAction } from 'redux-actions'

import { createRequestActions as request } from 'store/actionCreators'
import { ORG_VALUE_ADDED, ORG_VALUE_UPDATED } from 'app/constants/toastrMessages'
import { ORG_VALUES_CREATE_FORM } from 'app/constants/orgValues'

export const fetchOrgValues = request('ORG_VALUES/FETCH', organizationId => ({
  request: {
    url: `organizations/${organizationId}/organization-values`,
  },
}))

export const setOrgValuesView = createAction('ORG_VALUES/SET_VIEW')

export const saveOrgValue = request('ORG_VALUES/CREATE', ({ organizationId, editForm, data }) => ({
  request: {
    url: `organizations/${organizationId}/organization-values`,
    method: 'POST',
    data,
  },
  form: ORG_VALUES_CREATE_FORM,
  success: editForm ? ORG_VALUE_UPDATED : ORG_VALUE_ADDED,
}))

export const deleteOrgValue = request('ORG_VALUES/DELETE', ({ organizationId, valueId }) => ({
  request: {
    url: `organizations/${organizationId}/organization-values/${valueId}`,
    method: 'DELETE',
  },
  valueId,
  success: 'Organization value successfully deleted',
}))

export const valuesSelectPage = createAction('VALUES/SELECT_PAGE', (page: number) => ({ page }))

export const valuesSortBy = createAction('VALUES/SORT_BY', (by: string, desc: boolean) => ({ by, desc }))

export const setPending = createAction('VALUES/SET_PENDING', (field: string, value: boolean) => ({ field, value }))

export const setEditForm = createAction('VALUES_CHANGE_EDIT_FORM')
